export default class PersonDocumentDomainService {
    static fromJSON(json) {
        // Dates here are strings of millisecond values. We parse them as integers and then create dates from them.
        // @ts-expect-error - TS2740 - Type '{ createdDate: Date; expirationDate: any; }' is missing the following properties from type 'PersonDocument': id, fileId, description, createdBy, and 6 more.
        return Object.assign(Object.assign({}, json), { createdDate: new Date(parseInt(json.createdDate, 10)), expirationDate: json.expirationDate && new Date(parseInt(json.expirationDate, 10)) });
    }
}
